// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-sidebar {
  width: 280px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
#app-sidebar .sidebar-wrapper {
  background-color: #e6f6ff;
  border-right: 1px solid #c8e1f2;
  transition: width 0.8s ease-in-out;
  min-height: 100dvh;
}
@media (max-width: 992px) {
  #app-sidebar .sidebar-toggle-btn {
    position: absolute;
    right: 18px;
    background: transparent;
    top: 55px;
  }
  #app-sidebar .logo .logo-icon {
    text-align: left !important;
  }
  #app-sidebar .logo .logo-icon .logo-img {
    width: 80px;
    height: 80px;
    -o-object-fit: contain;
       object-fit: contain;
  }
}
#app-sidebar.collapsed {
  width: 0;
}
#app-sidebar.collapsed .sidebar-toggle-btn {
  right: -50px;
  transform: rotate(-180deg);
  top: 42px;
}
@media (min-width: 767px) {
  #app-sidebar.collapsed .sidebar-toggle-btn {
    top: 35px;
  }
}

#app-sidebar #sidebar-nav .nav-item {
  padding: 18px 10px 12px 20px;
  text-decoration: none;
}

#app-sidebar .logo {
  font-weight: bold;
  background-color: #e6f6ff;
}

#app-sidebar .sidebar-user {
  border-top: 1px solid #ddd;
}

#app-sidebar .menu-items {
  padding: 10px 15px 5px;
  font-size: 16px;
}
@media (max-width: 767px) {
  #app-sidebar .menu-items {
    font-size: 14px;
  }
}

.logo-icon {
  padding: 30px 10px;
}
.logo-icon .logo-img {
  width: 100px;
  height: 100px;
  -o-object-fit: contain;
     object-fit: contain;
}

.theme-btn {
  background-color: #ece63d;
  border: 1px solid #ece63d;
  max-width: 239px;
  width: 100%;
  height: 42px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #113b65;
}
.theme-btn:hover, .theme-btn:focus {
  background-color: #113b65;
  border: 1px solid #113b65;
  color: #ffffff;
}

.logout-btn {
  padding: 12px 24px;
  border-top: 1px solid #c8e1f2;
}
.logout-btn .user-profile {
  background-color: #f2f2f2;
  border: 1px solid #c8e1f2;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logout-btn .user-profile img {
  -o-object-fit: cover;
     object-fit: cover;
  width: 100%;
  height: 100%;
}
.logout-btn .user-profile svg {
  font-size: 20px;
}
.logout-btn ul li {
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #081021;
}
.logout-btn small {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #64748b;
}
.logout-btn .content {
  font-size: 16px;
}
@media (max-width: 767px) {
  .logout-btn .content {
    font-size: 14px;
  }
}

.custom-popover {
  border-radius: 8px;
  min-width: 180px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border: none;
  width: 290px;
  height: 228px;
  border-radius: 6px;
}

.user-settings-popover {
  padding: 8px;
}

.popover-user-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-email {
  font-weight: 500;
  font-size: 12px;
  color: #6c757d;
}

.popover-item:hover {
  background-color: #f5f5f5;
  border-radius: 8px;
}

.divider {
  margin: 8px 0;
}

.popover-item {
  padding: 10px;
  cursor: pointer;
}

.popover-content {
  border-radius: 8px;
  padding: 5px 0;
}

.popover-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background 0.3s ease;
}
.popover-item .upgrade {
  border-radius: 6px;
  width: 82px;
  height: 27px;
  background-color: #bfdfff;
  color: #113b65;
  font-weight: 500;
  font-size: 14px;
}

.popover-item:hover {
  background: #f0f0f0;
}

.rating-circle {
  width: 35px;
  height: 35px;
  background: #f2f2f2;
  border-radius: 50%;
  left: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid #ccc;
  font-weight: bold;
  transition: all 0.3s ease;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.rating-circle:hover, .rating-circle:focus, .rating-circle.active {
  background-color: #ece63d;
  border-color: #ece63d;
  color: #111111;
}

.menu-items .nav-menu {
  margin-top: 20px;
}
.menu-items .nav-menu .nav-menu-items {
  margin: 6px 0;
}
.menu-items .nav-menu .nav-menu-items .sidebar-items {
  border-radius: 40px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  justify-content: start;
  transition: gap 0.3s ease-in-out;
  font-weight: 500;
  color: #4f4f4f;
}
.menu-items .nav-menu .nav-menu-items .sidebar-items:hover, .menu-items .nav-menu .nav-menu-items .sidebar-items:focus, .menu-items .nav-menu .nav-menu-items .sidebar-items.active {
  background-color: #eef2ff;
  gap: 15px;
  color: #081021;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/themes/DYHAC/app/shared/layout/sidebar/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AACF;AACE;EACE,yBAAA;EACA,+BAAA;EACA,kCAAA;EACA,kBAAA;AACJ;AAEE;EACE;IACE,kBAAA;IACA,WAAA;IACA,uBAAA;IACA,SAAA;EAAJ;EAII;IACE,2BAAA;EAFN;EAIM;IACE,WAAA;IACA,YAAA;IACA,sBAAA;OAAA,mBAAA;EAFR;AACF;AAOE;EACE,QAAA;AALJ;AAQI;EACE,YAAA;EACA,0BAAA;EACA,SAAA;AANN;AAQM;EALF;IAMI,SAAA;EALN;AACF;;AAuCA;EACE,4BAAA;EACA,qBAAA;AApCF;;AA+EA;EACE,iBAAA;EACA,yBAAA;AA5EF;;AAgFA;EACE,0BAAA;AA7EF;;AAgFA;EACE,sBAAA;EACA,eAAA;AA7EF;AA+EE;EAJF;IAKI,eAAA;EA5EF;AACF;;AA+EA;EACE,kBAAA;AA5EF;AA8EE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;KAAA,mBAAA;AA5EJ;;AAgFA;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA7EF;AA+EE;EAEE,yBAAA;EACA,yBAAA;EACA,cAAA;AA9EJ;;AAkFA;EACE,kBAAA;EACA,6BAAA;AA/EF;AAiFE;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/EJ;AAiFI;EACE,oBAAA;KAAA,iBAAA;EACA,WAAA;EACA,YAAA;AA/EN;AAkFI;EACE,eAAA;AAhFN;AAqFI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAnFN;AAuFE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AArFJ;AAwFE;EACE,eAAA;AAtFJ;AAwFI;EAHF;IAII,eAAA;EArFJ;AACF;;AAyFA;EACE,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAtFF;;AAwFA;EACE,YAAA;AArFF;;AAuFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AApFF;;AAuFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AApFF;;AAuFA;EACE,aAAA;EACA,sBAAA;AApFF;;AAsFA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAnFF;;AAqFA;EACE,yBAAA;EACA,kBAAA;AAlFF;;AAqFA;EACE,aAAA;AAlFF;;AAqFA;EACE,aAAA;EACA,eAAA;AAlFF;;AAqFA;EAEE,kBAAA;EACA,cAAA;AAnFF;;AAsFA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;AAnFF;AAoFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAlFJ;;AAsFA;EACE,mBAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAnFF;AAqFE;EAGE,yBAAA;EACA,qBAAA;EACA,cAAA;AArFJ;;AA0FE;EACE,gBAAA;AAvFJ;AAyFI;EACE,aAAA;AAvFN;AAyFM;EACE,mBAAA;EACA,kBAAA;EA5RN,aAAA;EACA,mBA4R2B;EA3R3B,uBAAA;EACA,mBAAA;EACA,QAyRgC;EAC1B,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;AAnFR;AAqFQ;EAGE,yBAAA;EACA,SAAA;EACA,cAAA;AArFV","sourcesContent":["#app-sidebar {\n  width: 280px;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  // transition: width 0.8s ease-in-out;\n  .sidebar-wrapper {\n    background-color: #e6f6ff;\n    border-right: 1px solid #c8e1f2;\n    transition: width 0.8s ease-in-out;\n    min-height: 100dvh;\n  }\n\n  @media (max-width: 992px) {\n    .sidebar-toggle-btn {\n      position: absolute;\n      right: 18px;\n      background: transparent;\n      top: 55px;\n    }\n\n    .logo {\n      .logo-icon {\n        text-align: left !important;\n\n        .logo-img {\n          width: 80px;\n          height: 80px;\n          object-fit: contain;\n        }\n      }\n    }\n  }\n\n  &.collapsed {\n    width: 0;\n    // transition: width 0.8s ease-in-out;\n\n    .sidebar-toggle-btn {\n      right: -50px;\n      transform: rotate(-180deg);\n      top: 42px;\n\n      @media (min-width: 767px) {\n        top: 35px;\n      }\n    }\n  }\n}\n\n@mixin flex-center($direction: row, $gap: 10px) {\n  display: flex;\n  flex-direction: $direction;\n  justify-content: center;\n  align-items: center;\n  gap: $gap;\n}\n\n// #app-sidebar .logo {\n//   width: 185.62px;\n//   height: 30px;\n//   padding-top: 24px;\n//   left: 32px;\n//   padding: 0px;\n//   gap: 0px;\n//   margin: 0 auto;\n//   height: 100%;\n//   min-height: 80px;\n//   max-height: 80px;\n// }\n\n// #app-sidebar #sidebar-nav {\n//   padding-top: 25px;\n// }\n\n// #app-sidebar .logo img {\n//   padding: 24px 0px 0px 0px;\n// }\n\n#app-sidebar #sidebar-nav .nav-item {\n  padding: 18px 10px 12px 20px;\n  text-decoration: none;\n}\n\n// // #app-sidebar #sidebar-nav .nav-item .nav-link {\n// //   padding: 0;\n// //   color: #fff;\n// //   font-size: 18px;\n// //   font-weight: 400;\n// // }\n\n// .sidebar #sidebar-nav {\n//   background-image: url(../../../content/sidebar-gb.png);\n//   background-repeat: no-repeat;\n//   width: 100%;\n//   background-size: cover;\n//   height: 100%;\n//   max-height: 852px;\n//   min-height: 852px;\n// }\n\n// #app-sidebar #sidebar-nav a {\n//   padding: 0px 10px 34px 30px;\n//   text-decoration: none;\n//   color: #fff;\n// }\n\n// #app-sidebar #sidebar-nav a span {\n//   padding: 0;\n//   color: #fff;\n//   font-size: 18px;\n//   font-weight: 400;\n// }\n\n// #header-tabs .dropdown-menu {\n//   margin-top: 40px;\n// }\n\n// #header-tabs #account-menu {\n//   display: flex;\n//   justify-content: flex-end;\n//   flex-wrap: wrap;\n// }\n\n#app-sidebar .logo {\n  font-weight: bold;\n  background-color: #e6f6ff;\n  // border-bottom: 1px solid #ddd;\n}\n\n#app-sidebar .sidebar-user {\n  border-top: 1px solid #ddd;\n}\n\n#app-sidebar .menu-items {\n  padding: 10px 15px 5px;\n  font-size: 16px;\n\n  @media (max-width: 767px) {\n    font-size: 14px;\n  }\n}\n\n.logo-icon {\n  padding: 30px 10px;\n\n  .logo-img {\n    width: 100px;\n    height: 100px;\n    object-fit: contain;\n  }\n}\n\n.theme-btn {\n  background-color: #ece63d;\n  border: 1px solid #ece63d;\n  max-width: 239px;\n  width: 100%;\n  height: 42px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  color: #113b65;\n\n  &:hover,\n  &:focus {\n    background-color: #113b65;\n    border: 1px solid #113b65;\n    color: #ffffff;\n  }\n}\n\n.logout-btn {\n  padding: 12px 24px;\n  border-top: 1px solid #c8e1f2;\n\n  .user-profile {\n    background-color: #f2f2f2;\n    border: 1px solid #c8e1f2;\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    border-radius: 40px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      object-fit: cover;\n      width: 100%;\n      height: 100%;\n    }\n\n    svg {\n      font-size: 20px;\n    }\n  }\n\n  ul {\n    li {\n      list-style: none;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 20px;\n      color: #081021;\n    }\n  }\n\n  small {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #64748b;\n  }\n\n  .content {\n    font-size: 16px;\n\n    @media (max-width: 767px) {\n      font-size: 14px;\n    }\n  }\n}\n\n.custom-popover {\n  border-radius: 8px;\n  min-width: 180px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  border: none;\n  width: 290px;\n  height: 228px;\n  border-radius: 6px;\n}\n.user-settings-popover {\n  padding: 8px;\n}\n.popover-user-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n}\n\n.avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n}\n.user-email {\n  font-weight: 500;\n  font-size: 12px;\n  color: #6c757d;\n}\n.popover-item:hover {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\n.divider {\n  margin: 8px 0;\n}\n\n.popover-item {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.popover-content {\n  // background-color: #e6f6ff;\n  border-radius: 8px;\n  padding: 5px 0;\n}\n\n.popover-item {\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: background 0.3s ease;\n  .upgrade {\n    border-radius: 6px;\n    width: 82px;\n    height: 27px;\n    background-color: #bfdfff;\n    color: #113b65;\n    font-weight: 500;\n    font-size: 14px;\n  }\n}\n\n.popover-item:hover {\n  background: #f0f0f0;\n}\n\n.rating-circle {\n  width: 35px;\n  height: 35px;\n  background: #f2f2f2;\n  border-radius: 50%;\n  left: 33px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: 2px solid #ccc;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  user-select: none;\n\n  &:hover,\n  &:focus,\n  &.active {\n    background-color: #ece63d;\n    border-color: #ece63d;\n    color: #111111;\n  }\n}\n\n.menu-items {\n  .nav-menu {\n    margin-top: 20px;\n\n    .nav-menu-items {\n      margin: 6px 0;\n\n      .sidebar-items {\n        border-radius: 40px;\n        padding: 12px 16px;\n        @include flex-center(row, 4px);\n        justify-content: start;\n        transition: gap 0.3s ease-in-out;\n        font-weight: 500;\n        color: #4f4f4f;\n\n        &:hover,\n        &:focus,\n        &.active {\n          background-color: #eef2ff;\n          gap: 15px;\n          color: #081021;\n        }\n      }\n    }\n  }\n}\n\n// .modal-dialog.feedback-modal {\n//   max-width: 655px !important;\n//   height: 750px !important ;\n//   width: 100%;\n//   border-radius: 20px !important;\n//   .modal-content {\n//     @media (max-width: 576px) {\n//       width: calc(100% - 30px);\n//       margin: 0 auto;\n//     }\n//   }\n\n//   &.modal-dialog-centered {\n//     .modal-header {\n//       padding: 15px 18px;\n//      background-color: #FFFFFF !important;\n\n//       h5 {\n//         color:#111111 !important;\n//         font-size: 22px !important;\n//         font-style: normal;\n//         font-weight: 500 !important;\n//         line-height: normal;\n//       }\n//     }\n//     .modal-body {\n//       padding: 26px 27px 10px;\n//     }\n//     .modal-footer {\n//       padding: 13px 27px 26px;\n//       .download-button {\n//         margin: 0;\n//         display: block !important;\n//         font-size: 16px;\n//         font-style: normal;\n//         font-weight: 500;\n//         line-height: 20px;\n//         padding: 10px 20px;\n//         border-radius: 6px;\n\n//       }\n//     }\n//   }\n//   h6 {\n//     color: #353535;\n//     font-size: 14px;\n//     font-style: normal;\n//     font-weight: 500;\n//     line-height: 20px;\n//   }\n//   .text-muted {\n\n//     font-size: 12px;\n//     font-style: normal;\n//     font-weight: 400;\n//     line-height: 20px;\n//   }\n//   a.text-primary {\n//     color: #2b34de;\n//     font-size: 14px;\n//     font-style: normal;\n//     font-weight: 600;\n//     line-height: normal;\n//     text-decoration-line: underline;\n//   }\n//   .download-body {\n\n//     border: 1px solid #cacaca;\n\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
